var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-data-table',{attrs:{"dense":"","multi-sort":"","headers":_vm.headers,"items":_vm.surveys,"items-per-page":20,"items-per-page-options":[5,20,40],"footer-props":{
            showFirstLastPage: true,
            firstIcon: 'mdi-arrow-collapse-left',
            lastIcon: 'mdi-arrow-collapse-right',
            prevIcon: 'mdi-minus',
            nextIcon: 'mdi-plus',
               'items-per-page-text':'Anzahl Zeilen',
               'items-per-page-options':[5,20,40]
          }}}),(_vm.authorized)?_c('v-btn',{on:{"click":_vm.exp}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-cloud-download-outline")]),_vm._v(" "+_vm._s(_vm.$t('app.export'))+" ")],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }